import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from '../Sidebar';
import { Link } from 'react-router-dom';

const NewsVoiceList = () => {
  const [voices, setVoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchVoices = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/admin/news-voice`);
      setVoices(res.data); // Array of records
      setLoading(false);
    } catch (err) {
      console.error(err);
      setError('Failed to load data');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVoices();
  }, []);

  if (loading) return <p>🔄 Loading...</p>;
  if (error) return <p>❌ {error}</p>;

  return (
     <>

<div className="sidebar">
<Sidebar/>
</div>
    <div id="tabler">
        <Link type="button" class="btn btn-info" to={`/news-voice-upload`}>Create News Voice</Link>
        <br></br>
        <br></br>
        <h1>News Voice List</h1>
      {voices.length === 0 && <p>No data found.</p>}
      {voices.map((item) => (
        <div key={item._id} style={{ border: '1px solid #ccc', marginBottom: 10, padding: 10 }}>
          <p><strong>Date:</strong> {new Date(item.date).toLocaleDateString()}</p>
          {item.upload.map((file, idx) => (
            <div key={idx}>
              <audio controls src={file.url} style={{ width: '100%' }} />
            </div>
          ))}
        </div>
      ))}
     </div>
</>
  );
};

export default NewsVoiceList;
